module.exports = __webpack_public_path__ + "static/media/customer-chukde.d02c77d3.png";